module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-activity-logs/user-activity.logs.component.scss
// module id = 1242
// module chunks = 10